const showHide = () => {
  const allTabs = document.querySelectorAll(".tab");
  if (allTabs.length === 0) return false;
  const allPills = document.querySelectorAll(".pill");
  return (ID: string) => {
    allTabs.forEach(t => {
      if (t.id !== ID.slice(1)) {
        t.classList.add("hidden");
      } else {
        t.classList.remove("hidden");
      }
    });
    allPills.forEach(p => {
      if (p.getAttribute("href") === ID) {
        p.classList.add("pill-active");
      } else {
        p.classList.remove("pill-active");
      }
    });
  };
};

const toggleTabs = async () => {
  const allPills = document.querySelectorAll("a.pill");
  const toggle = showHide();
  if (toggle === false) return;
  if (window.location.hash) {
    toggle(window.location.hash);
  }
  allPills.forEach(a => {
    const href = a.getAttribute("href");
    if (href !== null && href.startsWith("#")) {
      a.addEventListener("click", () => {
        toggle(href);
      });
    }
  });
};

export default () => {
  toggleTabs();
};
